export const GRUSHKA_ORGANIZATION_ID = 'Crm-000-001';
export const BUSINESS_SOLUTION_ORGANIZATION_ID = 'Crm-000-002';
export const LASMOLLY_ORGANIZATION_ID = 'Crm-000-003';
export const RVB_ORGANIZATION_ID = 'Crm-000-014';
export const ABC_ORGANIZATION_ID = 'Crm-000-036';
